import React, { useRef} from "react";
import Icon from "../../forms/Icon"
import styled from "styled-components";
import { useHoverTooltip } from "../../HoverTooltip";

const flagIcon = (flag) => {
    let icons = {
        UnregisteredPlate : 'exclamationTriangle',
        SomeOtherAlert1 : 'flag'
    }

    return icons[flag] || 'flag'
}

const flagIconColor = (flag) => {
    let colors = {
        UnregisteredPlate : '#93090e',
        SomeOtherAlert1 : 'rgba(255, 153, 27, 1)'
    }

    return colors[flag] || '#ff9124ff'
}

export const translateFlag = (flag) => {
    let glossary = {
        UnregisteredPlate : 'Unregistered Plate',
        SomeOtherAlert1 : 'Surprise! It\'s a flag!'
    }

    return glossary[flag] || flag
}

const Wrapper = styled.div`
    position: relative;
    display: inline-block;
`

const Flag = ({ flag, ...props }) => {
    const wrapperRef = useRef(null);
    const { showTooltip, hideTooltip } = useHoverTooltip();

    const text = translateFlag(flag);

    const handleMove = (e) => {
        const el = wrapperRef.current;   
        if (!el) return;

        showTooltip({
        text,
        x: e.clientX,
        y: e.clientY,
        noWrap: false,
        maxWidth: 300,
        trigger: wrapperRef.current
        });
    };

    return (
        <Wrapper 
            ref={wrapperRef}
            onMouseMove={handleMove}
            onMouseLeave={() => hideTooltip(wrapperRef.current)}
        >
            <Icon
                icon={flagIcon(flag)}
                style={{ color: flagIconColor(flag), fontSize: "1.5em" }}
            />
        </Wrapper>
    );
};

export default Flag;